import React__default from 'react';
import clsx from 'clsx';
import { IconX } from '@tabler/icons';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import colors from '../../util/colors.js';
import styles from './Input.module.scss.js';

var ClearButton = function (props) {
    var handleClearInput = props.handleClearInput, alignRight = props.alignRight;
    var className = clsx(styles.InputCloseButton, alignRight && styles.InputCloseButton___left);
    return (React__default.createElement(ButtonBase, { onClick: handleClearInput, type: "button", "data-testid": 'clear-button', className: className, title: "Clear", style: {
            width: '2.75rem',
            height: '2.75rem',
            border: 'none',
            backgroundColor: 'transparent',
            left: alignRight ? 0 : 'unset',
        } },
        React__default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", style: {
                position: 'absolute',
                left: 'calc(50% - 9px)',
                top: 'calc(50% - 8.5px)',
            } },
            React__default.createElement("circle", { fill: "#BBC0CE", cx: "12", cy: "12", r: "9" })),
        React__default.createElement(IconX, { color: colors.white, size: 8 })));
};

export { ClearButton as default };
